<div class="recommendations" [appLoadingAnimation]="!isLoaded">
  <div class="recommendations__selection">
    <div class="recommendation__info">
      @if (abstractProducts.length === 1) {
        <h4 class="recommendation__info__title"
        >{{ 'contract-recommendations.your-option' | translate }}</h4>
      }
      @if (abstractProducts.length > 1) {
        <h4 class="recommendation__info__title"
        >{{ 'contract-recommendations.your-options' | translate }}</h4>
      }
      <p class="recommendation__info--desc">{{ 'contract-recommendations.your-options-desc' | translate }}</p>
      <button
        type="button"
        class="button" [attr.data-test]="'button-startOver'"
        (click)="goBackToStart()">
        {{ 'contract-recommendations.start-over' | translate }}
      </button>
      <button
        type="button"
        class="button recommendations__back-btn" [attr.data-test]="'button-back'"
        (click)="goBackOneStep.emit()">
        {{ 'guided-questions.answer-back-btn' | translate }}
      </button>
    </div>
    <div class="recommendation__options">
      @for (abstractProduct of abstractProducts; track abstractProduct) {
        <div class="recommendation__option">
          <h5 class="recommendation__option__title">{{ abstractProduct.attributes.name }}</h5>
          <h4 class="recommendation__option__price-scale">
            @for (expensiveness of [1,2,3,4]; track expensiveness) {
              <span [class.price]="abstractProduct.attributes.attributes.expensiveness >= expensiveness">$</span>
            }
          </h4>
          <div class="recommendation__option__desc">{{ abstractProduct.attributes.description }}</div>
          <div class="recommendation__option__additional-desc">{{ abstractProduct.attributes.attributes.second_description }}</div>
          <div class="recommendation__option__joined">
            @if (abstractProduct.attributes.attributes.available === '0') {
              <div
                class="recommendation__option__availability">
                {{ 'contract-recommendations.not-available-online' | translate }}
              </div>
            }
            @if (abstractProduct.attributes.attributes.available === '1') {
              <button
                type="button"
                class="recommendation__option__button button button--primary" [attr.data-test]="'button-select'"
                (click)="selectContract(abstractProduct.attributes.sku)">
                {{ 'contract-recommendations.select' | translate }}
              </button>
            }
            @if (abstractProduct.attributes.attributes.available !== '1') {
              <button
                type="button"
                class="recommendation__option__button button button--primary" [attr.data-test]="'button-contactUs'"
                (click)="contactUs(abstractProduct)">
                {{ 'contract-recommendations.contact-us' | translate }}
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div class="recommendations__info">
    <div class="recommendation__info">
      @for (attribute of infoItems; track attribute) {
        <div class="item">
          <p>{{ attribute.value }}</p>
          @if (hasTranslation('contract-recommendations.' + attribute.key)) {
            <app-tooltip
              class="accordion__category-details__info-icon"
              link="icon"
            text="{{ 'contract-recommendations.' + attribute.key | translate }}"></app-tooltip>
          }
        </div>
      }
    </div>
    <div class="recommendation__details">
      @for (abstractProduct of abstractProducts; track abstractProduct) {
        <div class="recommendation__detail">
          @for (attribute of infoItems; track attribute) {
            <p [innerHTML]="getDetailAttribute(abstractProduct.attributes.attributes[attribute.key])"></p>
          }
        </div>
      }
    </div>
  </div>
  @if (addItemInProgress) {
    <div class="recommendations__loader loader__overlay">
      <span class="loading-animation"></span>
    </div>
  }
</div>
